function init() {
	$("#btn-submit-contact-form").unbind("click");
	$("#btn-submit-contact-form").bind("click",function(e) {
		var form =  $(this).closest("form");
		var alert = form.find(".alert:first");
		alert.html("");
		alert.addClass("hide");
		
		$("#contact-key").val("Oj0dJq69nQ7X5tvQ5hk8jXXAgviFeVyn");
		
		$.ajax({
		   type: "POST",
		   url: form.attr("action"),
		   data: form.serialize(), 
		   success: function(data)
		   {
				if(!data.success){
					for(var i = 0; i < data.errors.length; i++){
					   alert.append("<p>&#x2022; " + data.errors[i] + "</p>")
					}
				   
					alert.removeClass("hide");
				}else{
					alert.addClass("hide");
					window.location.href = data.data;
				} 
		   }
		 });
		
		e.preventDefault();
	});
}

module.exports = {
	init : init
}